import React, {ReactNode} from 'react';
import {ResourceBlock} from '~/components/ResourcePage';
import style from './index.module.scss';

export interface IDetailsViewField {
    label: string;
    value: any;
}

export interface IDetailsViewProps {
    title?: string;
    fields: IDetailsViewField[];
    toolbar?: ReactNode;
}

export const DetailsView = ({title, toolbar, fields}: IDetailsViewProps) => <ResourceBlock title={title}>
    <div className={style.detailsView}>
        {fields.map((field, index) => [
            <div key={`label-${index}`} className={style.detailsLabel}>{field.label}:</div>,
            <div key={`value-${index}`} className={style.detailsValue}>{field.value}</div>
        ])}
    </div>
    {toolbar && <div className={style.detailsToolbar}>
        {toolbar}
    </div>}
</ResourceBlock>;
